// Backlog 072-B — trace-id shape detection.
//
// The API generates trace IDs in the form `d_<entity-segment>_<6-char-suffix>`
// (validated server-side at packages/api/src/routes/deploys.ts:13). The CLI
// uses the same regex to disambiguate `grid status <arg>` between an
// entity name/UUID and a deploy trace id without taking the round-trip.

export const TRACE_ID_RE = /^d_[a-z0-9]+_[a-z0-9]{6}$/;

export function isTraceId(value: string): boolean {
  return TRACE_ID_RE.test(value);
}
